import { CommonModule } from '@angular/common';
import { Component, input, output, signal, computed, effect } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { SelectFieldComponent, SelectOption } from '../select-field/select-field.component';

export interface ItemDropdownOption {
  id: string;
  label: string;
  disabled?: boolean;
  selected?: boolean;
}

@Component({
  selector: 'cm-item-dropdown',
  standalone: true,
  imports: [CommonModule, SelectFieldComponent, FormsModule],
  templateUrl: './item-dropdown.component.html',
  styleUrl: './item-dropdown.component.less',
})
export class ItemDropdownComponent {
  public readonly options = input.required<ItemDropdownOption[]>();
  public readonly disabled = input<boolean>(false);
  public readonly autId = input<string>('item-dropdown');
  public readonly placeholder = input<string>('Select an option');
  public readonly ariaLabel = input<string>('');
  /** Shows a spinner inside the panel while options are being fetched. */
  public readonly loading = input<boolean>(false);

  public readonly optionSelected = output<string>();
  public readonly opened = output<void>();

  protected readonly selectedValue = signal<string | null>(null);

  private readonly _selectedOption = computed(() => {
    return this.options().find((option) => option.selected);
  });

  protected readonly selectOptions = computed<SelectOption[]>(() => {
    return this.options().map(option => ({
      value: option.id,
      label: option.label,
      disabled: option.disabled ?? false
    }));
  });

  constructor() {
    effect(() => {
      const selected = this._selectedOption();
      this.selectedValue.set(selected ? selected.id : null);
    });
  }

  protected onSelectChange(value: string): void {
    this.selectedValue.set(value);
    this.optionSelected.emit(value);
  }

  protected onOpenedChange(isOpen: boolean): void {
    if (isOpen) {
      this.opened.emit();
    }
  }
}
